<div>
    <div class="row g-2">
        <div class="col-sm-5 col-lg-3">
            <div class="panel-row">
                <label for="dateStart" class="required">Date de début</label>
                <ed-datepicker
                    innerId="dateStart"
                    placeholder="Entrez une date "
                    required
                    [date]="dateStart"
                    (dateChange)="updateDateStart($event)"></ed-datepicker>
            </div>
        </div>
        <div class="col-sm-5 col-lg-3">
            <div class="panel-row">
                <label for="dateEnd " class="required">Date de fin</label>
                <ed-datepicker
                    innerId="dateEnd"
                    placeholder="Entrez une date "
                    required
                    [date]="dateEnd"
                    (dateChange)="updateDateEnd($event)"></ed-datepicker>
            </div>
        </div>
        <div class="col-sm-2 col-lg-2">
            <div class="panel-row">
                <label for="type " class="required">Pas de temps</label>
                <ed-select
                    [disableRipple]="true"
                    [disableOptionCentering]="true"
                    innerId="select-step "
                    placeholder="Sélectionner un pas de temps "
                    [options]="stepOptions || []"
                    [ngModel]="step"
                    (ngModelChange)="updateStep($event)">
                </ed-select>
            </div>
        </div>

        <div class="col-sm-2 col-lg-2">
            <div class="panel-row">
                <label for="type " class="required"></label>
                <ed-button
                    (click)="fetchData()"
                    [colorSchema]="allowReload() ? buttonColorsPrimary : buttonColorsSecondary"
                    >recharger</ed-button
                >
            </div>
        </div>
    </div>

    <br />

    <div class="row g-4">
        <div class="col-sm-12">
            <chart-card
                id="consumptionChart "
                [error]="!consumptions || consumptions.length == 0"
                [isLoading]="loading()"
                [series]="consumptions"
                [stacked]="true"
                [dataLabels]="consumptionsChartDataLabels"
                xaxisType="datetime"
                [yaxis]="[consumptionsChartYaxis]"
                [stroke]="{
                    curve: 'stepline',
                    width: 2,
                }"
                class="h-100"></chart-card>
        </div>
    </div>

    <br />

    <div class="row g-4">
        <div class="col-sm-12">
            <table-card
                [isLoading]="loading()"
                [dataSource]="consumptionsDataSource"
                [displayedColumns]="consumptionsDisplayedColumns">
            </table-card>
        </div>
    </div>
</div>
